import { Ramp } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { NewsLetterBoxTitle } from '../title';
import {
  NewsLetterBoxFormWithSubmit,
  NewsLetterBoxFormContent,
} from './components';

export const NewsLetterBoxForm = () => (
  <Ramp rampName="newsLetterFormWrapper">
    <NewsLetterBoxFormWithSubmit>
      <NewsLetterBoxTitle
        type="title"
      />
      <NewsLetterBoxTitle
        type="subTitle"
      />
      <NewsLetterBoxFormContent />
    </NewsLetterBoxFormWithSubmit>
  </Ramp>
);
